import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.383 1.5a1.17 1.17 0 0 0-.827.345l-.002.001-6.069 6.088a1.673 1.673 0 0 0 .002 2.345l1.705 1.734a1.63 1.63 0 0 0 1.788.36c.2-.083.38-.206.531-.36l.003-.002 5.697-5.746a.75.75 0 0 1 1.065 1.057l-5.694 5.742-.002.001a3.124 3.124 0 0 1-4.458 0l-1.704-1.733a3.173 3.173 0 0 1 0-4.452l.003-.003L7.491.788a2.665 2.665 0 0 1 3.783 0h.001l.676.676v.001a2.664 2.664 0 0 1 .001 3.782l-.001.001-5.377 5.396-.001.001a1.71 1.71 0 0 1-2.424 0l-.005-.006-.331-.34a1.71 1.71 0 0 1 .005-2.42l3.61-3.58a.75.75 0 0 1 1.056 1.064l-3.61 3.581a.21.21 0 0 0 0 .295l.01.01.332.34a.207.207 0 0 0 .293-.001v-.001l5.382-5.4.003-.004a1.166 1.166 0 0 0 0-1.654l-.002-.002-.68-.68-.002-.002a1.17 1.17 0 0 0-.827-.345",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceEditAttachment = { render };
export {
  interfaceEditAttachment as default,
  render
};
//# sourceMappingURL=interface-edit-attachment.svg.js.map
